module.exports = __webpack_public_path__ + "img/3_86.9c99bc9f.png";